import axios from 'axios'
import $store from '@/store/store.js'

const userMail = () => {
	let user = $store.getters.user
	return user.email
}

const onError = (error) => {
	if (error.message === 'Network Error') {
		$store.commit('set_nexus_api_status', false)
	}
}
const onSuccess = () => {
	$store.commit('set_nexus_api_status', true)
}

const ApiNexus = {
	install (Vue, options) {
		Vue.prototype.$ApiNexus = {
			// filesystem
			ls (path, deep = false, signal = null) {
				return new Promise((resolve, reject) => {
					let options = {
						baseURL: `${window.appConfig._$qobw6i}api/filesystem/ls/`,
						method: 'post',
						headers: {
							'Content-Type': 'application/json',
							token: `${window.appConfig._$xuicfs}`,
							from: userMail()
						},
						data: JSON.stringify({ path: path })
					}
					if (!deep) options.baseURL += '?deep=false'
					if (signal) options.signal = signal
					axios(options)
						.then(response => {
							onSuccess()
							resolve(response)
						})
						.catch(error => {
							if (axios.isCancel(error) || error.name === 'CanceledError') {
								const abortError = new Error('Aborted')
								abortError.name = 'AbortError'
								reject(abortError)
								return
							}
							onError(error)
							reject(error)
						})
				})
			},
			cat (path) {
				return new Promise((resolve, reject) => {
					let options = {
						baseURL: `${window.appConfig._$qobw6i}api/filesystem/cat/`,
						method: 'post',
						headers: {
							'Content-Type': 'application/json',
							token: `${window.appConfig._$xuicfs}`,
							from: userMail()
						},
						data: JSON.stringify({ path: path })
					}
					axios(options)
						.then(response => {
							onSuccess()
							resolve(response)
						})
						.catch(error => {
							onError(error)
							reject(error)
						})
				})
			},
			stat (path) {
				return new Promise((resolve, reject) => {
					let options = {
						baseURL: `${window.appConfig._$qobw6i}api/filesystem/stat/`,
						method: 'post',
						headers: {
							'Content-Type': 'application/json',
							token: `${window.appConfig._$xuicfs}`,
							from: userMail()
						},
						data: JSON.stringify({ path: path })
					}
					axios(options)
						.then(response => {
							onSuccess()
							resolve(response)
						})
						.catch(error => {
							onError(error)
							reject(error)
						})
				})
			},
			exist (path) {
				return new Promise((resolve, reject) => {
					let options = {
						baseURL: `${window.appConfig._$qobw6i}api/filesystem/exist/`,
						method: 'post',
						headers: {
							'Content-Type': 'application/json',
							token: `${window.appConfig._$xuicfs}`,
							from: userMail()
						},
						data: JSON.stringify({ path: path })
					}
					axios(options)
						.then(response => {
							onSuccess()
							resolve(response)
						})
						.catch(error => {
							onError(error)
							reject(error)
						})
				})
			},
			md5 (path) {
				return new Promise((resolve, reject) => {
					let options = {
						baseURL: `${window.appConfig._$qobw6i}api/filesystem/md5/`,
						method: 'post',
						headers: {
							'Content-Type': 'application/json',
							token: `${window.appConfig._$xuicfs}`,
							from: userMail()
						},
						data: JSON.stringify({ path: path })
					}
					axios(options)
						.then(response => {
							onSuccess()
							resolve(response)
						})
						.catch(error => {
							onError(error)
							reject(error)
						})
				})
			},
			mkdir (path) {
				return new Promise((resolve, reject) => {
					let options = {
						baseURL: `${window.appConfig._$qobw6i}api/filesystem/mkdir/`,
						method: 'post',
						headers: {
							'Content-Type': 'application/json',
							token: `${window.appConfig._$xuicfs}`,
							from: userMail()
						},
						data: JSON.stringify({ path: path })
					}
					axios(options)
						.then(response => {
							onSuccess()
							resolve(response)
						})
						.catch(error => {
							onError(error)
							reject(error)
						})
				})
			},
			touch (path, content, onProgress) {
				return new Promise((resolve, reject) => {
					let formData = new FormData()
					formData.append('path', path)
					formData.append('content', content)
					const config = {
						headers: {
							'content-type': 'multipart/form-data',
							token: `${window.appConfig._$xuicfs}`,
							from: userMail()
						},
						onUploadProgress: progressEvent => {
							if (progressEvent.isTrusted && progressEvent.lengthComputable) {
								let progress = Math.floor(
									progressEvent.loaded / progressEvent.total * 100
								)
								onProgress(progress)
							}
						}
					}
					let url = `${window.appConfig._$qobw6i}api/filesystem/touch/`
					axios.post(url, formData, config)
						.then(response => {
							onSuccess()
							resolve(response)
						})
						.catch(error => {
							onError(error)
							reject(error)
						})
				})
			},
			upload (path, file, onProgress) {
				return new Promise((resolve, reject) => {
					let formData = new FormData()
					formData.append('path', path)
					formData.append('file', file)
					const config = {
						headers: {
							'content-type': 'multipart/form-data',
							token: `${window.appConfig._$xuicfs}`,
							from: userMail()
						},
						onUploadProgress: progressEvent => {
							if (progressEvent.isTrusted && progressEvent.lengthComputable) {
								let progress = Math.floor(
									progressEvent.loaded / progressEvent.total * 100
								)
								onProgress(progress)
							}
						}
					}
					let url = `${window.appConfig._$qobw6i}api/filesystem/upload/`
					axios.post(url, formData, config)
						.then(response => {
							onSuccess()
							resolve(response)
						})
						.catch(error => {
							onError(error)
							reject(error)
						})
				})
			},
			download (path, onProgress) {
				return new Promise((resolve, reject) => {
					let options = {
						baseURL: `${window.appConfig._$qobw6i}api/filesystem/download/`,
						method: 'post',
						headers: {
							'Content-Type': 'application/json',
							token: `${window.appConfig._$xuicfs}`,
							from: userMail()
						},
						data: JSON.stringify({ path: path }),
						responseType: 'blob',
						onDownloadProgress: (progressEvent) => {
							if (progressEvent.total) {
								const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total)
								onProgress(percent)
							}
						}
					}
					axios(options)
						.then(response => {
							onSuccess()
							resolve(response)
						})
						.catch(error => {
							onError(error)
							reject(error)
						})
				})
			},
			download_url (path) {
				let url = `${window.appConfig._$qobw6i}api/filesystem/download/`
				return url + '?path=' + path
			},
			// Probe
			ffprobe (path) {
				return new Promise((resolve, reject) => {
					let options = {
						baseURL: `${window.appConfig._$qobw6i}api/probe/ffprobe/`,
						method: 'post',
						headers: {
							'Content-Type': 'application/json',
							token: `${window.appConfig._$xuicfs}`,
							from: userMail()
						},
						data: JSON.stringify({ path: path })
					}
					axios(options)
						.then(response => {
							onSuccess()
							resolve(response)
						})
						.catch(error => {
							onError(error)
							reject(error)
						})
				})
			},
			subtitle_probe (path) {
				return new Promise((resolve, reject) => {
					let options = {
						baseURL: `${window.appConfig._$qobw6i}api/probe/subtitle/`,
						method: 'post',
						headers: {
							'Content-Type': 'application/json',
							token: `${window.appConfig._$xuicfs}`,
							from: userMail()
						},
						data: JSON.stringify({ path: path })
					}
					axios(options)
						.then(response => {
							onSuccess()
							resolve(response)
						})
						.catch(error => {
							onError(error)
							reject(error)
						})
				})
			},
			// Vantage
			workflows () {
				return new Promise((resolve, reject) => {
					let options = {
						baseURL: `${window.appConfig._$qobw6i}api/vantage/workflows/`,
						method: 'post',
						headers: {
							'Content-Type': 'application/json',
							token: `${window.appConfig._$xuicfs}`,
							from: userMail()
						}
					}
					axios(options)
						.then(response => {
							onSuccess()
							resolve(response)
						})
						.catch(error => {
							onError(error)
							reject(error)
						})
				})
			},
			// Monitor
			mamAssetFinder (ref) {
				return new Promise((resolve, reject) => {
					let options = {
						baseURL: `${window.appConfig._$qobw6i}api/monitor/mam_asset_finder/`,
						method: 'get',
						headers: {
							'Content-Type': 'application/json',
							token: `${window.appConfig._$xuicfs}`,
							from: userMail()
						},
						params: { ref: ref }
					}
					axios(options)
						.then(response => {
							onSuccess()
							resolve(response)
						})
						.catch(error => {
							onError(error)
							reject(error)
						})
				})
			},
			// Misc
			client_ip (ref) {
				return new Promise((resolve, reject) => {
					let options = {
						baseURL: `${window.appConfig._$qobw6i}api/misc/client_ip/`,
						method: 'get',
						headers: {
							'Content-Type': 'application/json',
							token: `${window.appConfig._$xuicfs}`,
							from: userMail()
						}
					}
					axios(options)
						.then(response => {
							onSuccess()
							resolve(response)
						})
						.catch(error => {
							onError(error)
							reject(error)
						})
				})
			},
			suifa_asset_info (ref) {
				return new Promise((resolve, reject) => {
					let options = {
						baseURL: `${window.appConfig._$qobw6i}api/asset/raw/`,
						method: 'get',
						headers: {
							'Content-Type': 'application/json',
							token: `${window.appConfig._$xuicfs}`,
							from: userMail()
						},
						params: { ref: ref }
					}
					axios(options)
						.then(response => {
							onSuccess()
							resolve(response)
						})
						.catch(error => {
							onError(error)
							reject(error)
						})
				})
			},
			suifa_of_info (num_of) {
				return new Promise((resolve, reject) => {
					let options = {
						baseURL: `${window.appConfig._$qobw6i}api/of/raw/`,
						method: 'get',
						headers: {
							'Content-Type': 'application/json',
							token: `${window.appConfig._$xuicfs}`,
							from: userMail()
						},
						params: { of: num_of }
					}
					axios(options)
						.then(response => {
							onSuccess()
							resolve(response)
						})
						.catch(error => {
							onError(error)
							reject(error)
						})
				})
			},
			// Behive
			reindex_asset (id) {
				console.log('reindex_asset')
				return new Promise((resolve, reject) => {
					let options = {
						baseURL: `${window.appConfig._$qobw6i}api/behive/reindex_asset/`,
						method: 'get',
						headers: {
							'Content-Type': 'application/json',
							token: `${window.appConfig._$xuicfs}`,
							from: userMail()
						},
						params: { id: id }
					}
					axios(options)
						.then(response => {
							onSuccess()
							console.log('reindex_asset, response', response)
							resolve(response)
						})
						.catch(error => {
							onError(error)
							console.log('reindex_asset, error', error)
							reject(error)
						})
				})
			}
		}
	}
}

export default ApiNexus



// WEBPACK FOOTER //
// ./src/api/nexus_api.js